import axios from 'axios';

import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import { resolveURLPath } from 'utils/urlHelpers';


class EmailPlugin {
  enable = async({ username }) => {
    const baseUrl = ConfigurationService.get(ConfigurationKeys.BASE_URL);
    const url = new URL(baseUrl);
    url.pathname = resolveURLPath(url.pathname, `${username}/edit/twoFa`);

    const data = new URLSearchParams({ 'action': 'enableEmail2FA' });

    const requestDetails = {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      withCredentials: true,
    };

    const result = {
      req: { ...requestDetails, url: url.toString() },
      res: undefined,
      data: undefined,
      error: undefined,
    };

    try {
      const res = await axios.post(url.toString(), data, requestDetails);
      result.data = res?.data || undefined;
      result.res = res;
    } catch (error) {
      result.error = error;
    }

    return result;
  };
}

export default new EmailPlugin();
